export const portfolioData = {
  personal: {
    name: "Théotime Perrichet",
    title: "Robotics & Software Test Engineer",
    tagline: "Building intelligent systems that bridge the physical and digital worlds through automated testing and AI innovation",
    bio: "Driven Robotics Engineering graduate from Lyon, France, with international experience at BMW Japan and BMW Munich. I specialize in automated testing, HMI development, computer vision, and robotics systems. Thriving in fast-paced, collaborative, diverse environments with a global perspective.",
    location: "Lyon, France",
    email: "theotime.tp.perrichet@gmail.com",
    github: "https://github.com/TheoTime01",
    githubUsername: "TheoTime01",
    linkedin: "https://www.linkedin.com/in/theotime-perrichet/",
    languages: ["French (Native)", "English (Fluent - C1)", "German (B1)"],
    role: "Robotics & Software Test Engineer",
    affiliation: "M.S. Robotics Engineering",
    institution: "CPE Lyon"
  },

  focus: {
    chips: [
      "Automated Testing",
      "Robotics / ROS2",
      "Computer Vision",
      "HMI & ADAS",
      "Machine Learning"
    ],
    statement: "My work sits where software quality engineering meets robotics: designing automated test suites that keep safety-critical automotive software honest, and building autonomous systems that have to survive the physical world. At BMW in Munich and Tokyo I maintained ECU test benches, wrote automated HMI test scripts and ran SiL/HiL simulations against Japanese and European compliance requirements, alongside computer-vision models for defect detection. Outside the test bench I build robots — quadrupeds, drones and interactive robot heads — where perception, navigation and human-robot interaction have to work together rather than in isolation."
  },
  
  skills: {
    programming: ["Python", "C++", "C", "Java", "JavaScript", "HTML", "CSS", "PHP", "PowerShell"],
    robotics: ["ROS2", "SLAM", "Gazebo", "Arduino", "Raspberry Pi", "Hardware Integration", "Sensor Fusion", "Navigation", "Naoqi", "Pepper Robot"],
    ai_ml: ["PyTorch", "Computer Vision", "Machine Learning", "OpenCV", "HCI", "Neural Networks", "Data Mining", "TensorFlow", "NLP", "Transformer Models", "OpenAI API"],
    testing: ["Selenium", "Pytest", "HMI Testing", "Automated Testing", "SiL/HiL Simulations", "ECU Testing", "ADAS Testing"],
    tools: ["Git", "Linux", "Docker", "DevOps", "Bazel", "Flask", "AWS", "Azure", "REST APIs", "Matlab", "LabView", "VIM", "SolidWorks", "CAD", "Jira", "Confluence"],
    automotive: ["AUTOSAR", "ISO 26262", "ISO 21434", "JASO Standards", "ECU Programming", "CAN", "Ethernet"],
    desktop: ["Microsoft Excel", "Microsoft Word", "Microsoft PowerPoint", "Power BI", "Microsoft Outlook", "Microsoft Teams"],
    other: ["Data Visualization", "Data Analysis", "Networking", "TCP", "UDP", "Shell Scripting", "SQL", "Android"]
  },
  
  projects: [
    {
      id: 8,
      title: "Whimsically Britt - Travel Website Rebuild",
      subtitle: "Full rebuild of a travel content creator's website and trip-planning business",
      description: "Freelance full-stack rebuild of letslivewhimsically.com for Whimsically Britt, a solo-travel content creator and travel planner. One platform now carries her blog, her paid trip-planning services and a members-only subscription, with an admin she runs herself.",
      technologies: ["React", "FastAPI", "PostgreSQL"],
      features: [
        "Custom admin to write, schedule and manage posts, media, prices and pages",
        "Trip-planning service pages with booking flows",
        "Paid subscription for members-only posts",
        "User accounts and SEO-ready pages"
      ],
      links: [
        { label: "Website", url: "https://www.letslivewhimsically.com" },
        { label: "YouTube", url: "https://www.youtube.com/@whimsicallybritt" },
        { label: "Instagram", url: "https://www.instagram.com/whimsicallybritt" }
      ],
      page: "/projects/whimsically-britt",
      category: "Web/Freelance",
      image: "/images/whimsically-britt.webp"
    },
    {
      id: 1,
      title: "Spok - Quadruped Robot",
      subtitle: "Boston Dynamics Spot-inspired robot for hazardous environments",
      description: "An affordable quadruped robot designed for firefighting operations, built with ROS2 and featuring autonomous navigation, manual control, and real-time video feedback.",
      technologies: ["ROS2 Humble", "Raspberry Pi", "Python", "Gazebo", "Nav2", "OpenCV"],
      features: [
        "Autonomous navigation in simulation",
        "Manual joystick control with video feedback",
        "Obstacle detection with ultrasonic sensors",
        "Cost-effective design (~€200 total cost)"
      ],
      github: "https://github.com/TheoTime01/Spok--Boston-Dynamics-Spot-inspired-robot",
      video: "https://youtu.be/bJ2OreaSHS8",
      page: "/projects/spok",
      category: "Robotics",
      image: "/images/spok2.jpg"
    },
    {
      id: 2,
      title: "ChatMoov - Interactive Robot Head",
      subtitle: "Face tracking robot with ChatGPT integration",
      description: "INMOOV robot head with advanced face tracking and natural language interaction powered by ChatGPT API, featuring synchronized mouth movements and real-time conversation.",
      technologies: ["Python", "OpenAI API", "Arduino", "OpenCV", "Speech Recognition"],
      features: [
        "Real-time face detection and tracking",
        "ChatGPT-powered natural conversations",
        "Speech-to-text with OpenAI Whisper",
        "Synchronized mouth and head movements"
      ],
      github: "https://github.com/TheoTime01/ChatMoov",
      video: "https://www.youtube.com/playlist?list=PLxonWIbIdwC61nbJOSWWsmZ7bKpfgkA30",
      page: "/projects/chatmoov",
      category: "AI/Robotics",
      image: "/images/chatmoov.webp"
    },
    {
      id: 3,
      title: "Tello Drone with ROS2",
      subtitle: "Autonomous drone control and QR code interaction",
      description: "DJI Tello EDU integration with ROS2 for autonomous flight, featuring QR code-triggered behaviors, manual control, and advanced trajectory management.",
      technologies: ["ROS2 Humble", "Python", "OpenCV", "DJI Tello", "Computer Vision"],
      features: [
        "Precise 3D trajectory control",
        "QR code triggered autonomous behaviors",
        "XBOX joystick manual control",
        "Multiple operational modes (manual, monitoring, travelling)"
      ],
      github: "https://github.com/TheoTime01/Tello-drone-with-ROS2",
      video: "https://youtu.be/YJ8u02rbd7Y",
      page: "/projects/tello",
      category: "Robotics/AI",
      image: "/images/tello/tello-edu.jpg"
    },
    {
      id: 4,
      title: "NanoGolf - 3D Game Engine",
      subtitle: "Custom 3D mini-golf simulation with physics",
      description: "From-scratch 3D mini-golf game built with Python and OpenGL 3.3, featuring custom physics engine, dynamic camera system, and realistic collision detection.",
      technologies: ["Python", "OpenGL 3.3", "GLSL Shaders", "NumPy", "PyOpenGL"],
      features: [
        "Custom physics engine with realistic ball dynamics",
        "Modern OpenGL 3.3+ rendering pipeline",
        "Dynamic camera following system",
        "Multiple challenging levels with teleportation mechanics"
      ],
      github: "https://github.com/MaaatGrv/NanoGolf",
      category: "Graphics/Game Dev",
      image: "/images/nanogolf.jpg"
    },
    {
      id: 5,
      title: "Pokemon Recommendation System",
      subtitle: "ML-powered recommendation engine",
      description: "Data mining project implementing multiple machine learning algorithms to create a Pokemon recommendation system based on user preferences and image analysis.",
      technologies: ["Python", "Scikit-learn", "Jupyter", "Decision Trees", "Random Forest", "Neural Networks"],
      features: [
        "Multiple ML model comparison (Decision Tree, Random Forest, Neural Networks)",
        "Dominant color extraction using MiniBatchKMeans",
        "User preference-based recommendations",
        "Comprehensive model evaluation with 81%+ accuracy"
      ],
      github: "https://github.com/TheoTime01/Project_DataMining",
      page: "/projects/pokemon",
      category: "Machine Learning",
      image: "/images/pokemon.jpg"
    },
    {
      id: 6,
      title: "Griot AI - African Language Translator",
      subtitle: "Western African language translation with AI",
      description: "A specialized translator for Western African languages, focusing on the Bambara family. Built to bridge communication gaps and democratize information access for African communities using transformer-based models.",
      technologies: ["Python", "TensorFlow", "Flask", "Transformer Models", "NLP"],
      features: [
        "English to Bambara family language translation",
        "Transformer-based architecture for high accuracy",
        "Modular design for future language extensions",
        "Focus on underrepresented African languages"
      ],
      github: "https://github.com/Waranika/Bam-translator",
      category: "AI/NLP",
      image: "/images/griot-ai.jpg"
    },
    {
      id: 7,
      title: "Human-Robot Interaction (HRI) Ethics",
      subtitle: "Ethical considerations in robot behavior design",
      description: "An exploration of ethical HRI through dual scenarios using Pepper robot. Demonstrates both ethical and non-ethical robot behaviors, highlighting design choices' impact on user perception and trust in human-robot interactions.",
      technologies: ["Python", "Naoqi", "Pepper Robot", "HTML", "CSS", "JavaScript", "Choregraphe"],
      features: [
        "Dual ethical vs non-ethical robot behavior scenarios",
        "Integrated tablet interface for enhanced interaction",
        "Natural language dialogue system with ALDialog",
        "Web service connectivity for dynamic content"
      ],
      github: "https://github.com/TheoTime01/Human-Robot-Interaction-HRI-Project",
      video: "https://youtu.be/tRi2CV4AP5A",
      page: "/projects/hri",
      category: "HRI/Ethics",
      image: "/images/pepper-the-robot.jpg"
    }
  ],
  
  experience: [
    {
      title: "Verification & Validation Engineer Consultant – LCV Range",
      company: "Volvo Group",
      location: "Lyon, France",
      duration: "Dec 2025 - Present",
      description: "Akkodis consultant for Volvo Group – Light Commercial Vehicles (LCV) range.",
      sections: [
        {
          heading: "Verification Lead",
          items: [
            "Plan and manage test environments: software, tools, vehicles and test benches",
            "Configure Production and QA environments",
            "Run software and system tests: unit, non-regression and functional validation",
            "Analyse test results and recommend fixes and improvements",
            "Manage anomalies and track bugs, including testing and reproducing issues",
            "Write test reports and summaries, and report to project teams",
            "Monitor quality"
          ]
        },
        {
          heading: "Development Lead",
          items: [
            "Analyse, write and update technical specifications",
            "Review and validate technical specifications",
            "Unit-test operations on vehicles and benches, including fault simulation",
            "Analyse the system architecture through frames and logs",
            "Create and improve documentation processes"
          ]
        }
      ],
      logo: "/images/volvo-logo.svg",
      partner: "Akkodis",
      partnerLogo: "/images/akkodis-logo.png"
    },
    {
      title: "Software Test Engineer",
      company: "BMW Japan",
      location: "Tokyo, Japan",
      duration: "Feb 2025 - Aug 2025",
      description: "Designed automated HMI test scripts, executed SiL/HiL simulations for Japanese automotive compliance, developed Computer Vision AI for defect detection, and collaborated with German QA teams.",
      logo: "/images/bmw-logo.svg"
    },
    {
      title: "Student Freelance",
      company: "JUWA",
      location: "Lyon, France",
      duration: "Aug 2024 - Jan 2025",
      description: "Created UTM URLs for marketing campaign tracking in Google Analytics and built dynamic dashboards for data synthesis and decision-making enhancement.",
      logo: "/images/juwa-logo.webp"
    },
    {
      title: "Software Test Engineer",
      company: "BMW Group",
      location: "Munich, Germany",
      duration: "Jul 2023 - Jul 2024",
      description: "Maintained ECU test benches, assisted in programming ADAS features, collaborated on ECU tool enhancement, and documented testing procedures for standardization.",
      logo: "/images/bmw-logo.svg"
    },
    {
      title: "Fulfillment Associate",
      company: "Amazon",
      location: "Montelimar, France",
      duration: "Jun 2022",
      description: "Prepared customer orders accurately and ensured optimal packaging for shipping. Labeled and sorted goods by destination to streamline delivery logistics.",
      logo: "/images/amazon-logo.webp"
    }
  ],

  education: [
    {
      degree: "Master's Degree in Robotics Engineering",
      institution: "CPE Lyon",
      location: "Lyon, France",
      graduation: "Jan 2026",
      description: "Specializing in robotics, AI integration, and automated systems with international experience in Japan and Germany.",
      logo: "/images/cpe-logo.png"
    },
    {
      degree: "Japanese Language Immersive Program",
      institution: "EF Education",
      location: "Tokyo, Japan",
      graduation: "Jul 2024",
      description: "Intensive Japanese language and cultural immersion program enhancing global communication skills.",
      logo: "/images/wix-logo.jpg"
    },
    {
      degree: "Bachelor's Degree in Computer Science",
      institution: "CPE Lyon",
      location: "Lyon, France",
      graduation: "Jun 2023",
      description: "Foundation in computer science, programming, and software development principles.",
      logo: "/images/cpe-logo.png"
    }
  ]
};

export const testimonials = [
  {
    name: "Academic Supervisor",
    role: "Project Advisor",
    content: "Théotime demonstrates exceptional ability to integrate complex systems and solve real-world robotics challenges.",
    avatar: "/api/placeholder/100/100"
  },
  {
    name: "Project Collaborator",
    role: "Team Member",
    content: "Outstanding technical skills and innovative approach to robotics development. A pleasure to work with.",
    avatar: "/api/placeholder/100/100"
  }
];
